import { sdk, API_FUNCTIONS, queryClient, queryKeys, RULES_ENDPOINTS, checkIfGreatSuccess } from 'utils/query';
import { RuleItem } from 'models/rules';
import { useTranslation } from 'react-i18next';
import { ApiTaskResult } from 'models/general';
import { useCustomMutation } from '../useCustomMutation';

interface DeleteRuleProps {
  item: RuleItem;
}

const deleteRule = async ({ item }: DeleteRuleProps) => {
  const result = await sdk.tasks.api.delete<ApiTaskResult>(
    API_FUNCTIONS.monitoring,
    `${RULES_ENDPOINTS.monitoringRules}/${item.id}`,
    {},
  );
  return checkIfGreatSuccess({ result });
};

export const useDeleteRule = () => {
  const { t } = useTranslation();
  return useCustomMutation({
    fn: deleteRule,
    onSuccess: {
      message: t('success_data_deleted', { value: t('alerts_rule_label') }),
      callback: async (_result, variables) => {
        const {
          item: { patientId, groupId },
        } = variables;

        const queryKey = patientId
          ? [`${queryKeys.patientRules}-${patientId}-${groupId}`]
          : [`${queryKeys.groupRules}-${groupId}`];

        await queryClient.invalidateQueries({ queryKey });
      },
    },
  });
};
